import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FileQueueObject, FileuploadService } from '../services/fileupload.service';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-file-uploader',
	templateUrl: './file-uploader.component.html',
	styleUrl: './file-uploader.component.scss'
})
export class FileUploaderComponent implements OnInit, OnDestroy {
	@Output() onCompleteItem = new EventEmitter();
	@ViewChild('fileInput') fileInput!: { nativeElement: any; };
	queue!: Observable<FileQueueObject[]>;
	filenames: any = "";
	fetchingPresignedURL = false;

	constructor(private apiService: ApiService, public uploader: FileuploadService, private toastr: ToastrService) { }

	ngOnDestroy(): void {
		try {
			this.uploader.clearQueue();
		} catch (error) { }
	}

	ngOnInit(): void {
		this.queue = this.uploader.queue;
		this.uploader.onCompleteItem = this.completeItem;
	}

	completeItem = (item: FileQueueObject, response: any) => {
		this.onCompleteItem.emit({ item, response });
		item.uploaded_name = item.temp_name;
		item.uploaded_content_type = item.temp_content_type;
		item.uploaded_url = item.temp_url;
		item.uploaded_size = item.temp_size;
	}

	addToQueue() {
		const fileBrowser = this.fileInput.nativeElement;
		let sizeLimit = 20;
		let unitLimit1 = "MB";
		let unitLimit2 = "GB";
		let files = fileBrowser.files;
		for (let file of files) {
			let _size = file.size;
			let fSExt = new Array('Bytes', 'KB', 'MB', 'GB');
			let i = 0;
			while (_size > 900) {
				_size /= 1024;
				i++;
			}
			let exactSize = (Math.round(_size * 100) / 100);
			if ((fSExt[i] == unitLimit1 && exactSize > sizeLimit) || fSExt[i] == unitLimit2) {
				this.toastr.error("Max file size allowed is " + sizeLimit + " " + unitLimit1, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
		}
		let names = $.map(files, function (val: any) { return val.name; });
		this.filenames = names.join(", ");
		this.fetchingPresignedURL = true;
		this.apiService.fileUploadMultiple(names, environment.MAIL_FILE_UPLOAD_DESTINATION).subscribe({
			next: (res) => {
				this.fetchingPresignedURL = false;
				let fileDataList: any = [];
				for (let i = 0; i < res.length; i++) {
					fileDataList.push({
						temp_name: res[i][0].file_name,
						temp_content_type: res[i][0].file_ext,
						temp_url: res[i][0].file_url,
						s3_url: res[i][0].presigned_url,
						file: fileBrowser.files[i],
						temp_size: fileBrowser.files[i].size,
					})
				}
				this.uploader.addToQueue(fileDataList);
			}, error: (error) => {
				this.fetchingPresignedURL = false;
			}
		});
	}

	getAttachments() {
		let attachment: any[] = [];
		this.queue.forEach((data: any) => {
			for (var i = 0; i < data.length; ++i) {
				if (data[i].uploaded_content_type != undefined && data[i].uploaded_name != undefined && data[i].uploaded_url != undefined && data[i].uploaded_size != undefined) {
					let obj = {
						"content-type": data[i].uploaded_content_type,
						name: data[i].uploaded_name,
						url: data[i].uploaded_url,
						size: data[i].uploaded_size
					}
					attachment.push(obj);
				}
			}
		});
		return attachment;
	}
}
